<div *ngIf="isPageReady" class="flex flex-col h-full">
  <!-- Header info - Table layout for read-only values -->
  <div class="mb-4 shrink-0 p-3 rounded-md bg-primary-50 dark:bg-primary-900">
    <table class="text-sm text-left">
      <colgroup>
        <col class="w-28" />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <td class="font-semibold pr-2 py-1 whitespace-nowrap">Manufacturer:</td>
          <td class="py-1">{{ productType.manufacturer?.name }}</td>
        </tr>
        <tr>
          <td class="font-semibold pr-2 py-1 whitespace-nowrap">SKU:</td>
          <td class="py-1">{{ productType.style }}</td>
        </tr>
        <tr>
          <td class="font-semibold pr-2 py-1 whitespace-nowrap">Product Type:</td>
          <td class="py-1">{{ productType.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Main content area -->
  <div class="flex flex-row gap-3 flex-1 min-h-0">
    <!-- Left side, feed-driven. The manufacturer says which sizes exist in which color, so there is
         no size to choose and no cross-multiply to make. Which colors to carry is still a
         purchasing decision, so that part stays. -->
    <div *ngIf="isFeedDriven" class="flex flex-col w-1/2 h-full">
      <div class="mb-2 font-semibold shrink-0">
        {{ isSizeOnlyFeed ? "Sizes the manufacturer makes in this style" : "Colors the manufacturer makes in this style" }}
      </div>

      <div *ngIf="!isSizeOnlyFeed" class="mb-2 shrink-0 flex items-center gap-2 text-sm">
        <p-checkbox
          [binary]="true"
          [ngModel]="areAllFeedColorsSelected"
          (onChange)="onAllFeedColorsToggled($event.checked)"
          inputId="allFeedColors"
        />
        <label for="allFeedColors" class="cursor-pointer">Select every color</label>
      </div>

      <div class="flex-1 min-h-0 overflow-auto border rounded-md" style="border-color: var(--p-surface-300, #d1d5db)">
        <div
          *ngFor="let c of feedColors"
          class="flex items-center gap-2 px-3 py-2 text-sm border-b"
          style="border-color: var(--p-surface-200, #e5e7eb)"
        >
          <p-checkbox
            [binary]="true"
            [ngModel]="isFeedColorSelected(c)"
            (onChange)="onFeedColorToggled(c, $event.checked)"
            [inputId]="'feedColor' + c.FeatureChoiceId"
          />
          <label [for]="'feedColor' + c.FeatureChoiceId" class="cursor-pointer flex-1">
            {{ c.ChoiceValue }}
            <span
              *ngIf="c.FeedColorName && c.FeedColorName !== c.ChoiceValue"
              style="color: var(--p-text-muted-color, #6b7280)"
            >
              ({{ c.FeedColorName }})
            </span>
          </label>
          <span style="color: var(--p-text-muted-color, #6b7280)">
            {{ c.Sizes.length }} size{{ c.Sizes.length === 1 ? "" : "s" }}
          </span>
        </div>
      </div>

      <div class="mt-2 shrink-0 text-sm">
        The system builds {{ feedNewCount }} product{{ feedNewCount === 1 ? "" : "s" }}.
        <span *ngIf="feedBuildCount > feedNewCount" style="color: var(--p-text-muted-color, #6b7280)">
          {{ feedBuildCount - feedNewCount }} of the {{ feedBuildCount }} already exist.
        </span>
      </div>
    </div>

    <!-- Left side: Feature selection -->
    <div *ngIf="!isFeedDriven" class="flex flex-col w-1/2 h-full">
      <div class="mb-2 font-semibold shrink-0">Select Feature Choices to add to Products</div>
      <div class="mb-3 shrink-0">
        <p-listbox
          class="w-full"
          [options]="features"
          [(ngModel)]="selectedFeature"
          optionLabel="name"
          dataKey="id"
          (onClick)="onFeatureClick($event)"
          [listStyle]="{ 'max-height': '150px' }"
        >
          <ng-template pTemplate="selectedItem">
            <div class="flex w-full" *ngIf="selectedFeature">
              <div class="w-1/2">{{ selectedFeature.name }}</div>
              <div class="w-1/2">{{ formatSelectedChoices(selectedFeature) }}</div>
            </div>
          </ng-template>
          <ng-template let-feature pTemplate="item">
            <div class="flex w-full">
              <div class="w-1/2">{{ feature.name }}</div>
              <div class="w-1/2">{{ formatSelectedChoices(feature) }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </div>
      <app-ag-grid [gridOptions]="featureChoiceGridOptions" [rowData]="featureChoices" [hasColSizeButtons]="false" [hasClearFiltersButton]="false" class="flex-1 min-h-0"></app-ag-grid>
    </div>

    <!-- Right side: Current Products -->
    <div class="flex flex-col w-1/2 h-full">
      <div class="mb-2 font-semibold shrink-0">Current Products</div>
      <app-ag-grid [gridOptions]="productGridOptions" [hasColSizeButtons]="false" [hasClearFiltersButton]="false" class="flex-1 min-h-0"></app-ag-grid>
    </div>
  </div>

  <!-- Footer buttons -->
  <div class="flex items-center pt-3 shrink-0">
    <div class="flex gap-2">
      <button
        pButton
        type="button"
        class="p-button-raised"
        icon="pi pi-plus"
        [disabled]="!canGenerate()"
        (click)="isFeedDriven ? onGenerateFromFeed() : onGenerate()"
      >
        <span>Generate!</span>
      </button>
      <button pButton type="button" class="p-button-raised" [disabled]="!uow.hasChanges()" (click)="ok()">
        <span>Save and Close</span>
      </button>
      <button pButton type="button" class="p-button-raised p-button-secondary" (click)="cancel()">
        <span>{{ uow.hasChanges() ? "Cancel" : "Close" }}</span>
      </button>
    </div>
  </div>
</div>
